const AliasRegexHome = () => import(/* webpackChunkName: "group-pabx-cadastros-regex" */ '../_views/AliasRegexHome')
const CadastroRegex = () => import(/* webpackChunkName: "group-pabx-cadastros-regex" */ '../_views/CadastroRegex')
const AtualizarRegex = () => import(/* webpackChunkName: "group-pabx-cadastros-regex" */ '../_views/AtualizarRegex')

import { permissionsPabx } from '../../../../../utils/permissionsPabx'

export default [
  {
    path: 'aliasregex',
    component: AliasRegexHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Aliasregex',
  },
  {
    path: 'aliasregex/criar',
    component: CadastroRegex,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Aliasregex/criar',
  },
  {
    path: 'aliasregex/atualizar/:_id',
    component: AtualizarRegex,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Aliasregex/atualizar',
    props: true,
  },
]
